import { render, staticRenderFns } from "./DialogGeofencing.vue?vue&type=template&id=c874531c&scoped=true"
import script from "./DialogGeofencing.vue?vue&type=script&lang=js"
export * from "./DialogGeofencing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c874531c",
  null
  
)

export default component.exports